// =============================================================================
// TypingIndicator.tsx — Animated three-dot typing indicator (web port)
// =============================================================================

import React from 'react';
import { Box, keyframes } from '@mui/material';
import { useTheme } from '../../context/PermissionsContext/ThemeContext/ThemeContext';

const DOT_SIZE = 8;

const pulse = keyframes`
  0%, 100% { opacity: 0.3; }
  50% { opacity: 1; }
`;

const TypingIndicator: React.FC = () => {
  const { theme } = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        my: 0.5,
        px: 1.5,
      }}
      role="status"
      aria-label="AI is typing"
    >
      <Box
        sx={{
          maxWidth: '80%',
          borderRadius: '12px',
          p: 1.5,
          backgroundColor: theme.background2,
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          height: 20,
        }}
      >
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            sx={{
              width: DOT_SIZE,
              height: DOT_SIZE,
              borderRadius: '50%',
              backgroundColor: theme.secondary,
              animation: `${pulse} 1.2s ease-in-out infinite`,
              animationDelay: `${i * 0.2}s`,
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default TypingIndicator;
